import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户相关信息
    // userInfo:window.sessionStorage.getItem("userInfo"),
    // 当前的步骤条
    curStep:2,
    // 预算表单
    budgetForm: {
      endId: "", //起始id
      startId: "", //终点id
      startCName: '', //起点名
      endCName: '', //终点名
    },
    // 保存信件数量
    letterNum:0,
    // 实际总量
    weight:0,
    // 下单数据
    orderVo:{
    // 订单基本信息
    order: {
      "adNumberId": 0,
      "belongNumber": "",
      "belongTypeId": 0,
        // 货币类型编号
      "currency": "",
      "datetime": "",
      "day": 0,
      "endName": "",
      "endNameEn": "",
      "endTime": "",
      "id": 0,
      "memberId": 0,
      "number": "",
      "orderRemarks": "",
      "pickNumber": "",
      "pickPicture": "",
        // 订单金额
      "price": 0,  
      "realityPrice": 0,
      "realityVolume": 0,
      "realityWeight": 0,
        // 线路ID
      "routeId": 0,
      "routePrice": 0,
      "startName": "",
      "startNameEn": "",
      "startTime": "",
      "statusId": 0,
      "surchargeId": 0,
      "typeId": 0,
      "upsPrice": 0,
      "userId": 0,
      // 报关时使用发票要提交的pdf
      detailedPdf: [],
      // 总数量
      totalCount:0,
        // 订单体积总重量
      "volume": 0,
        // 订单实际总重量
      "weight": 0,
      // 最早取件时间
      startTime:"",
      // 最晚取件时间
      endTime:'',
      // 取件日期
      pickupDate:"",
    },
    // 订单报价邮件尺寸重量信息
    orderBoxes: [],
    // 订单邮件物品申报信息
    orderDetail: [],
    // 订单收件人和发货人信息
    orderUsers: [
    ]
    },
    // 当前寄件的类型,用于过滤其他不同的箱子
    boxType:"01",
    // 起点国家图片
    startSelect: '',
    // 终点国家图片
    endSelect: '',
    // 重点国家图片

    // 报关上传的文件列表
    fileList: [],
  },
  mutations: {
    // 更新重量
    UPDATEWEIGHT(state,weight){
      state.weight= weight
      state.orderVo.order.weight = weight
    },
    // 更新物品类别
    UPDATEITEMTYPE(state,itemtype){
      state.mail.customsForm.itemType = itemtype
    },
    // 切换步骤条
    CHANGESTEP(state,step){
      console.log(step, 'change1')
      state.curStep = step
    },
    // 添加商品种类
    ADDGOODTYPE(state,good){
      state.orderVo.orderDetail.unshift(good)
    },
    // 删除商品种类
    DELETEGOOD(state,orderDetail){
      state.orderVo.orderDetail = orderDetail
    },
    // 设置起点终点
    SETSHIPMENT(state,dataObj){
      state.budgetForm.startId = dataObj.startId
      state.budgetForm.endId = dataObj.endId
      state.budgetForm.startCName = dataObj.startName
      state.budgetForm.endCName = dataObj.endName
    },
    // 设置预算价格和路由id
    SETPRICE(state,obj){
      console.log(obj,"路由对象")
      state.orderVo.order.price = obj.price
      state.orderVo.order.routeId = obj.routeId
    },
    // 添加物品
    ADDORDERBOX(state,Box){
      state.orderVo.orderBoxes.push(Box)
    },
    // 添加收货人或寄件人信息
    ADDORDERUSER(state,info){
      state.orderVo.orderUsers.push(info)
    },
    // 初始化预算表单
    INITBUDGET(state){
      state.budgetForm ={
        endId:"",
        startId:"",
        weight:0
      }
    },
    // 依据id增加箱子数量
    INCREMENTBOXCOUNT(state,index){
      state.orderVo.orderBoxes[index].count++
    },
    // 依据id增加箱子数量
    DECREMENTBOXCOUNT(state,index){
      state.orderVo.orderBoxes[index].count--
    },
    // 初始化订单收件人和发货人
    INITORDERUSER(state){
      state.orderVo.orderUsers = []
    },
    // 更新箱子列表
    UPDATEBOXLIST(state,boxList){
      state.orderVo.orderBoxes = boxList
    },
    // 更新信件数量
    UPDATELETTNUM(state,num){
      state.letterNum = num
    },
    // 设置订单备注
    SETORDERREMARKS(state,remarks){
      state.orderVo.orderRemarks = remarks
    },
    // 设置日期时间
    SETTIME(state,dateObj){
      let {pickupDate,startTime,endTime} = dataObj
      state.orderVo.order.endTime = endTime
      state.orderVo.order.startTime = startTime
      state.orderVo.order.pickupDate = pickupDate
    },
    // 切换寄件类型
    CHANGEBOXTYPE(state,type){
      console.log("我收到了类型",type)
      state.boxType = type
    },
    // 设置起点或者重点图片
    SETIMAGE(state,obj){
      state[obj.el] = obj.image
    },
    // 修改
    EDITGOOD(state, attr){
      console.log('执行修改')
      console.log(  state.orderVo.orderDetail[attr.index])
      state.orderVo.orderDetail[attr.index].count = attr.count
      state.orderVo.orderDetail[attr.index].price = attr.price
      console.log(state.orderVo.orderDetail[attr.index].price )
    },
    // 加入报关pdf路径到参数
    SETdetailedPdf(state, value){
      state.orderVo.order.detailedPdf.push(value)
    },
    // 删除报关pdf路径
    DELETEdetailedPdf(state, index){
      state.orderVo.order.detailedPdf.splice(index, 1)
    }
  },
  actions: {
    // 删除物品
    deleteGood(context,frontID){
      let newGoodList = context.state.orderVo.orderDetail.filter(item=>{
        return item.frontID != frontID
      })
      context.commit("DELETEGOOD",newGoodList)
    },
    // 修改箱子的参数
    editBox(context,option){
      let {id,type,box} = option
      let boxList = context.state.orderVo.orderBoxes
      switch(type){
        case "increment":
          boxList.forEach((item,index)=>{
            if(item.id===id) context.commit("INCREMENTBOXCOUNT",index)
          })
        break;

        case "decrement":
          boxList.forEach((item,index)=>{
            if(item.id===id) context.commit("DECREMENTBOXCOUNT",index)
          })
        break;

        case "delete":
            context.commit("UPDATEBOXLIST",boxList.filter(item=>{
              return item.id != id
            }))
          break;

        case "edit":
          let newBoxList= []
          boxList.forEach(item=>{
            if(item.id==id){
              item = box
            }
            newBoxList.push(item)
          })
          context.commit("UPDATEBOXLIST",newBoxList)
          break;
      }
    },
    // 修改物品申报物品的参数
    editGood(contact, options){
      let {id, count, price} = options
      
      let goodList = contact.state.orderVo.orderDetail
      goodList.forEach((item, index) => {
        if(item.frontID == id){
          contact.commit('EDITGOOD', {count, price, index})
        }
      })
    }
  },
  modules: {
  },
  getters:{
    // 总件数
    totalParts(state){
      let num = 0;
      if(state.boxType == "01"){
         // 当前boxType为01
         state.orderVo.orderBoxes.forEach(item => {
           if(item.boxType == "01"){
             num += item.count - 0
           }
         })
      }else{
        // 当前boxType不为01
        state.orderVo.orderBoxes.forEach(item => {
        if(item.boxType != "01"){
            num += item.count - 0
          }
        })
      }
      state.orderVo.order.totalCount = num
      return num
    },
    // 总重量
    totalVolume(state){
      let volume = 0
      if(state.boxType == "01"){
        // 当前boxType为01
        state.orderVo.orderBoxes.forEach(item => {
          if(item.boxType == "01"){
            volume += ((item.count - 0) * (item.volume - 0))
          }
        })
      }else{
        // 当前boxType不为01
        state.orderVo.orderBoxes.forEach(item => {
          if(item.boxType != "01"){
            volume += ((item.count - 0) * (item.volume - 0))
          }
        })
      }
      state.orderVo.order.volume = volume
      return volume
    },
  }
})
